import {
    CREATE_GENERAL_DC_INWARD_FAILURE_DK,
    CREATE_GENERAL_DC_INWARD_REQUEST_DK,
    CREATE_GENERAL_DC_INWARD_SUCCESS_DK,
    CREATE_USER_FORM_GENERAL_DC_INWARD_DK,
    FETCH_SINGLE_GENERAL_DC_INWARD_FAILURE_DK,
    FETCH_SINGLE_GENERAL_DC_INWARD_REQUEST_DK,
    FETCH_SINGLE_GENERAL_DC_INWARD_SUCCESS_DK,
    FETCH_GENERAL_DC_INWARD_FAILURE_DK,
    FETCH_GENERAL_DC_INWARD_REQUEST_DK,
    FETCH_GENERAL_DC_INWARD_SUCCESS_DK,
    NAVIGATE_GENERAL_DC_INWARD_DETAILS_DK,
    NAVIGATE_GENERAL_DC_INWARD_DK,
    GENERAL_DC_INWARD_USERFORM_RESET_DK,
    UPDATE_GENERAL_DC_INWARD_FAILURE_DK,
    UPDATE_GENERAL_DC_INWARD_REQUEST_DK,
    UPDATE_GENERAL_DC_INWARD_SUCCESS_DK,
    DELETE_GENERAL_DC_INWARD_REQUEST_DK,
    DELETE_GENERAL_DC_INWARD_SUCCESS_DK,
    DELETE_GENERAL_DC_INWARD_FAILURE_DK,
    FETCH_PENDING_GENERAL_DC_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_GENERAL_DC_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_GENERAL_DC_IN_INWARD_FAILURE_DK,
    SET_ACTIVE_KEY_GENERAL_DC_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_GENERAL_DC_INWARD_ID_DK
} from './generalDCInward.actionsType';

export const GENERAL_DC_INWARD_DK = 'generalDCInwardDK';

let initialState = {
    loading: false,
    generalDCInward: [],
    pendingGeneralDC: [],
    activeKey: 1,
    generalDCInwardId: '',
    generalDCInwardMasterForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldRoundoff: 0
    },
    selectedGeneralDCInward: {},
    isGeneralDCInward: false,
    generalDCInwardSelectedValue: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let generalDCInwardDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_GENERAL_DC_INWARD_REQUEST_DK:
        case FETCH_PENDING_GENERAL_DC_IN_INWARD_REQUEST_DK:
        case CREATE_GENERAL_DC_INWARD_REQUEST_DK:
        case FETCH_SINGLE_GENERAL_DC_INWARD_REQUEST_DK:
        case UPDATE_GENERAL_DC_INWARD_REQUEST_DK:
        case DELETE_GENERAL_DC_INWARD_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_GENERAL_DC_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalDCInward: updatePayload
            };
        case FETCH_PENDING_GENERAL_DC_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingGeneralDC: updatePayload
            };
        case CREATE_GENERAL_DC_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalDCInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                generalDCInwardId: updatePayload[0]?.fldID,
                activeKey: updatePayload[0]?.fldID && payload ? 2 : 1
            };
        case FETCH_SINGLE_GENERAL_DC_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedGeneralDCInward: updatePayload,
                generalDCInwardMasterForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case UPDATE_GENERAL_DC_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedGeneralDCInward: {},
                generalDCInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                }
            };
        case DELETE_GENERAL_DC_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalDCInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                selectedGeneralDCInward: {}
            };
        case FETCH_GENERAL_DC_INWARD_FAILURE_DK:
        case FETCH_PENDING_GENERAL_DC_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_GENERAL_DC_INWARD_FAILURE_DK:
        case CREATE_GENERAL_DC_INWARD_FAILURE_DK:
        case UPDATE_GENERAL_DC_INWARD_FAILURE_DK:
        case DELETE_GENERAL_DC_INWARD_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_GENERAL_DC_INWARD_DK:
            return {
                ...state,
                loading: false,
                generalDCInwardMasterForm: {
                    ...state.generalDCInwardMasterForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_GENERAL_DC_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case GENERAL_DC_INWARD_USERFORM_RESET_DK:
            return {
                ...state,
                generalDCInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                selectedGeneralDCInward: {},
                generalDCInwardId: '',
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_GENERAL_DC_INWARD_ID_DK:
            return {
                ...state,
                generalDCInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_GENERAL_DC_INWARD_DETAILS_DK:
            return {
                ...state,
                isGeneralDCInward: true,
                generalDCInwardSelectedValue: updatePayload.generalDCInwardSelectedValue
            };
        case NAVIGATE_GENERAL_DC_INWARD_DK:
            return {
                ...state,
                isGeneralDCInward: false
            };
        default:
            return state;
    }
};
